// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'

// Style
import themeColors from 'assets/theme/colors'
import { getFontBody } from '@/assets/theme/fonts'

export default function WhereWeWorkSection() {
  const { t } = useTranslation('technology')

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader eyebrow={t('where.eyebrow')} title={t('where.title')} />

      <Typography
        component="p"
        fontSize={getFontBody()}
        sx={{
          lineHeight: 1.7,
          color: themeColors.gray.defaultText,
          maxWidth: '52rem'
        }}
      >
        {t('where.p1')}
      </Typography>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
